import React from "react";

const Schedule = () => {
  return (
    <div className="w-full flex flex-col">
      <div>
        <h2 className="font-Bangers text-4xl md:text-2xl">Take a Note!</h2>
      </div>
      <div>
        <div>
          <table class="w-[500px] 2xl:w-[400px] table-auto border-4 border-white border-solid font-Oswald text-lg md:text-sm border-separate rounded-xl bg-white opacity-70">
            <thead className="border-4 border-red-600 border-solid bg-red-600">
              <tr className="text-xl">
                <th>Date</th>
                <th>Venue</th>
                <th>City</th>
              </tr>
            </thead>
            <tbody>
              <tr className="even:bg-gray-600 odd:text-gray-500">
                <td>January 25th, 2025 1:00pm</td>
                <td>Two Macs Midday Barbershop Comedy Show</td>
                <td>Washington, DC</td>
              </tr>
              <tr className="even:bg-gray-600 odd:text-gray-500">
                <td>February 7th, 2025 8:00pm</td>
                <td>The Electric Palm </td>
                <td>Woodbridge, Virginia</td>
              </tr>
              <tr className="even:bg-gray-600 odd:text-gray-500">
                <td>February 22nd, 2025 1:00pm</td>
                <td>Two Macs Barbershop Coat Comedy Jam</td>
                <td>Washington, DC</td>
              </tr>
              <tr className="even:bg-gray-600 odd:text-gray-500">
                <td>February 28th, 2025 1:00pm</td>
                <td>Bigg Mike Birthday Bash</td>
                <td>Washington, DC</td>
              </tr>
              <tr className="even:bg-gray-600 odd:text-gray-500">
                <td>March 4th, 2025 1:00pm</td>
                <td>Sanford and Son Stage</td>
                <td>Washington, DC</td>
              </tr>
              <tr className="even:bg-gray-600 odd:text-gray-500">
                <td>March 22nd, 2025 1:00pm</td>
                <td>The Tony Viagra Birthday Zoom</td>
                <td>Washington, DC</td>
              </tr>
              <tr className="even:bg-gray-600 odd:text-gray-500">
                <td>March 15th, 2025 1:00pm</td>
                <td>Art of the Republic Comedy Show</td>
                <td>Cleveland, OH</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h5 className="text-lg 2xl:text-sm sm:text-xs text-gray-200">
            *suggested to check the schedule frequently for any changes.
          </h5>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
